import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { MonthRangePicker } from "@viniarruda/react-month-range-picker";
import Icon from './Icon';

const MonthPicker = ({ icon, datepicker, datetitle, startDate, endDate, handleDateRangeChange }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);  // will hold {startMonth,startYear,endMonth,endYear}

  return (
    <div className="datepicker d-flex align-items-center  justify-content-end">
      <div className='date-range-label text-nowrap'>Select Date Range:</div>
      <InputGroup className="ml-16">
        <div className="">
          <Icon type="svg" name={icon} className=" calendar-btn-icon w-h-20 cursor-pointer" />
          <>
            <button
              className="calendar-btn"
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              {startDate.getMonth() + 1}/{startDate.getFullYear()} → {endDate.getMonth() + 1}/{endDate.getFullYear()}
            </button>
            {showDatePicker && (
              <div className="my-calendar">
                <MonthRangePicker

                  locale="en-US"        // any BCP-47 tag your browser supports
                  onRangeSelect={(range) => {
                    if (range) {
                      handleDateRangeChange(range);
                      setShowDatePicker(false);
                    }
                  }}
                  calendarClassname="my-calendar"  // for custom styling (optional)
                />
              </div>
            )}
          </>
          {/* <DatePicker
            showMonthYearPicker
            selected={startDate}
            onChange={(update) => handleDateRangeChange(update)}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            placeholderText="Select Date Range"
            dateFormat="MMM yyyy"
            isClearable={false}
            className={`formcont-rol text-16 fw-400 pr-21 text-center pt-7 pb-7 border-0 rounded-3 pl-46 ${datepicker}`}
          /> */}
        </div>

      </InputGroup>

    </div>
  );
};

export default MonthPicker;
